






























































import Vue from 'vue'
import { getNestedValue } from '@/util/helpers'
import { DataTableHeader } from 'vuetify/types'

interface DataOptions {
  loading: boolean
  page: number
  pageCount: number
  itemsPerPage: number
  headers: DataTableHeader[]
  editedRows: { [id: number]: boolean }
}

export default Vue.extend({
  data(): DataOptions {
    return {
      loading: false,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        {
          text: 'Název projektu',
          value: 'projectName',
          sortable: false,
        },
        {
          text: 'Developer',
          value: 'developer',
          sortable: false,
        },
        {
          text: 'Okres',
          value: 'districtDesc',
          sortable: false,
        },
        {
          text: 'Správní obvod',
          value: 'municipalityDesc',
          sortable: false,
        },
        {
          text: 'Městská část',
          value: 'landAreaDesc',
          sortable: false,
        },
        {
          text: 'Celkem bytů',
          value: 'appartmentCount',
          sortable: false,
        },
        {
          text: 'Počet volných bytů',
          value: 'appartmentCountFree',
          sortable: false,
        },
        {
          text: '',
          value: 'action',
          sortable: false,
          align: 'center',
        },
      ],
      editedRows: {},
    }
  },
  computed: {
    projects(): any[] {
      return getNestedValue(
        this.$store.getters['valuationEdit/data'],
        ['transactionData', 'transactions', 'projects'],
        []
      )
    },
  },
  methods: {
    toggleProject(item: any) {
      if (this.editedRows[item.projectID] === undefined) {
        this.editedRows = {
          ...this.editedRows,
          [item.projectID]: item.disabled,
        }
      } else {
        this.editedRows = {
          ...this.editedRows,
          [item.projectID]: !this.editedRows[item.projectID],
        }
      }

      this.$store.commit('valuationEdit/addProjectGroupsEdit', {
        categoryKey: 'transactions',
        edit: {
          [item.projectID]: this.editedRows[item.projectID],
        },
      })
    },
    isRowDisabled(item: any): boolean {
      if (this.editedRows[item.projectID] === undefined) {
        return item.disabled
      }

      return !this.editedRows[item.projectID]
    },
  },
})
